import Vue from 'vue'
import VueI18n from 'vue-i18n'
import brText from './br.json'

Vue.use(VueI18n)

let language = 'br'
const i18n = new VueI18n({
  locale: language,
  messages: { br: brText },
})
export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js